
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';


/**
  * In this file there are some Objects interface
*/
@Injectable({
  providedIn: 'root'
})
export class GlobalService {

  constructor(private readonly router: Router) { }

  /** Check the current route of the application
   *
   * Main use in Navbar Component
   */
  public checkRoute(chemin: string): string {
    let id = ''
    if (this.router.url.startsWith(chemin)) {
      id = 'actif'
    }
    return id
  }
}

/**
  * Here you can modify/add Compromise Reports (Policies Violations) properties
*/
export interface CompromiseReports {
  id?: string;
  bwAppId?: string;
  timestamp?: number;
  deviceId?: string;
  appInfo?: AppInfo
  bwInfo?: BwInfos
  deviceInfo?: BwDeviceInfo
  location?: Location
  detectors?: Array<Detectors>
  createdAt?: number
}

/**
  * Part of Compromise Reports && Attestations
*/
export interface AppInfo {
  appId?: string;
  appInstallationTimestamp?: number;
  appName?: string;
  appVersion?: string
}

/**
  * Part of Compromise Reports && Attestations
*/
export interface BwInfos {
  bwDetectorIds?: number[];
  families?: string[];
  bwCompromiseType?: string;
  bwSdkVersion?: string;
  bwPolicyVersion?: string;
}

/**
  * Part of Compromise Reports && Attestations
*/
export interface BwDeviceInfo {
  fingerprint?: string;
  product?: string;
  industrialDeviceName?: string;
  securityPatchLevel?: string;
  manufacturer?: string;
  platformName?: string;
  board?: string;
  model?: string;
  bootloader?: string;
  apiLevel?: string;
  kernelVersion?: string;
  platformVersion?: string;
  romName?: string;
  architecture?: string
}

/**
  * Part of Compromise Reports && Attestations
*/
export interface Location {
  latitude?: number;
  longitude?: number;
  countryCode?: string;
  country?: string;
  city?: string;
  region?: string
}

/**
  * Part of Compromise Reports && Attestations
*/
export interface Detectors {
  id?: number
  family: string
  name: string
  technicalId?: string
}

/**
  * Here you can modify/add Attestation properties
*/
export interface Attestation {
  id?: string;
  bwAppId?: string;
  timestamp?: number;
  deviceId?: string;
  appInfo?: AppInfo
  bwInfo?: BwInfos
  deviceInfo?: BwDeviceInfo
  location?: Location
  createdAt?: number
  contentHash?: string
  metadata?: Object
  probes?: any
  score_prevention?: Score
  alert?: number
}

/**
  * Item received with GET request in Compromission && Attestation controllers
  *
  * field results is a Compromissions Report or Attestation list transformed in string
  *
  * others fields are useful for pagination
*/


export interface CommonFieldsResults{
  results: string
  totalNbRows: number
  pageSize: number
  nextPageToken: number
  nbPages: number
}

export interface BwObjectPromise extends CommonFieldsResults{
  distinctAppNamesAndVersions: string
  distinctBwVersions: string
  distinctModelNames: string
  distinctVersionsAndroid: string
  distinctVersionsIos: string
  distinctVersionsIpados: string
}

/**
  * Part of Attestations
*/
export interface Score {
  id: string,
  platform?: string
  ruleset?: string
  scorePrevention?: number
  subscoresPrevention?: {
    scoreBehavior?: number,
    scoreBw?: number,
    scoreDebugger?: number,
    scoreHardware?: number,
    scoreHook?: number,
    scoreIntegrity?: number,
    scoreLocation?: number,
    scoreMemory?: number,
    scoreRoot?: number,
    scoreSensitive?: number,
    scoreSensors?: number,
    scoreSoftware?: number,
    scoreStatus?: number,
    scoreUtils?: number,
    scoreVirtualisation?: number,
    scoresHelper: {
      totalBehavior?: number,
      invalidBehavior?: number,
      totalBw?: number,
      invalidBw?: number,
      totalDebugger?: number,
      invalidDebugger?: number,
      totalHardware?: number,
      invalidHardware?: number,
      totalHook?: number,
      invalidHook?: number,
      totalIntegrity?: number,
      invalidIntegrity?: number,
      totalLocation?: number,
      invalidLocation?: number,
      totalMemory?: number,
      invalidMemory?: number,
      totalRoot?: number,
      invalidRoot?: number,
      totalSensitive?: number,
      invalidSensitive?: number,
      totalSensors?: number,
      invalidSensors?: number,
      totalSoftware?: number,
      invalidSoftware?: number,
      totalStatus?: number,
      invalidStatus?: number,
      totalUtils?: number,
      invalidUtils?: number,
      totalVirtualisation?: number,
      invalidVirtualisation?: number,
    }
  },
  blacklistsTriggered?: string[],
  whitelistsTriggered?: string[]
  greylistsTriggered?: Greylist[],
  globalWeight?: number
  totalRulechecks?: number,
  invalidRulechecks?: number,
  rulesTriggered?: string[],
  travelVelocity?: number,
}

/**
  * Part of Score
*/
export interface Greylist {
  name?: string,
  weight?: number,
  belongs?: boolean,
}

/**
  * Item of all differents choices for search request of Compromise Reports && Attestations
*/
export interface BwFilters {
  bwSdkVersions?: string[],
  platformNames?: string[]
  models?: string[]
  from?: number
  to?: number
  id?: string
  deviceId?: string
  bwAppId?: string
  metadata?: string
  appNamesAndVersions?: any
  androidPlatformVersions?: string[]
  iosPlatformVersions?: string[]
  page?: number
  pageSize?: number
}

export interface RequestPolicy{
  id?: number
  name: string
  idBW: number
  activatedDetectors?: ActivatedDetector[]
  clientName?: string
}

/**
  * Here you can modify/add policies properties
*/
export interface Policy {
  id?: number
  name: string
  status?: string
  creationDate?: string
  activationDate?: string
  submittedDate?: string
  desactivationDate?: string
  refusedDate?: string
  activatedDetectors?: ActivatedDetector[]
  bwVersion?: BwVersion
  clientApplication?: ClientApplication
  clientPolicyDto?:Client
}



/**
  * Part of Policy && BwVersion Entity
*/
export interface BwVersion {
  id: number
  os: string
  version: string
  listDetectors?: Detectors[]
}

/**
  * Part of BwVersion
*/
export interface ActivatedDetector {
  detectorId?: number
  launchOnDemand: boolean
  launchOnPeriodic: boolean
  policyDetectorId?: {
    detector: Detectors
  }
  status: string
}

/**
  * Part of Policy && Application Entity
*/
export interface ClientApplication {
  packageName: string
  id?: number
  client?: Client
  clientId?: number
  os?: string
  policy?: Policy[]
}


/**
  * Part of BwVersion && Client Entity
*/
export interface Client {
  id?: number
  name: string
}


/**
  * Parameters for Request a simulation
*/
export interface RequestSimulation {
  applicationId: number
  startDate?: Date,
  endDate?: Date,
  nbAttestations?: number
}
/**
  * Object send by the Api when a Simulation request is send (not Finish)
*/
export interface ResultSimulation {
  nbAttest: number,
  nbAttestSimulated: number,
  nbComproSimulated: number,
  mapDetActual: Object
  mapDetNew: Object
  nbCompro: number
}

/**
  * Futur object for ResultSimulation used
*/
export interface DetectSimulation {
  family: string
  counter : number
  detectors?: [
    {
      occurrence: number,
      detector: Detectors
    }
  ]
}

export interface RefPolicy {
  id:number
  name:string
  type:string
  client?: Client
}

export interface RequestRefPolicy{
  name:string
  type:string
  clientId?: number
  id?: number
}

export interface ResponseSds{
  syncUpdateDetectors:any
}

/*
*  Web Protector Browser Attestation part
*/

export interface WpObjectPromise extends CommonFieldsResults{
  distinctSdkVersions:string
  distinctApplicationsNames:string
  distinctOsNamesAndVersions:string
  distinctBrowserNamesAndVersions:string
}

export interface WpFilters {
  from?: number
  to?: number
  id?: string
  userId?: string
  metadata?: string
  page?: number
  pageSize?: number
  sdkVersions?: string[]
  applicationsNames?: string[]
  osNamesAndVersions?: any
  browserNamesAndVersions?: any
}

export interface BrowserAttestation{
  id:string
  userId:string
  otjsId:string
  timestamp:number
  metadata?:Object
  createdAt?:number
  appInfo?:AppInfo
  wpInfo?:WpInfo
  deviceInfo?:WpDeviceInfo
  IDS?: IdsObject
  location?:Location
  ip:string
  components?:WpComponents
}

export interface WpInfo{
  wpSdkVersion:string
}

export interface WpDeviceInfo{
  browserName?:string
  browserMajorVersion?:string
  browserFullVersion?:string
  osName?:string
  osVersion?:string
  device:string
  userAgent?:string
}

export interface IdsObject{
  probes?:IdsProbes
  detectors?: Map<string, string>
}

export interface IdsProbes{
  architecture?:number
  fetchNativeCode?:string
  isFidoAvailable?:boolean
  metrics?:Map<string, number>
  otjsContent?:string
  vmSensors?:VmSensors
}

export interface VmSensors{
  availHeight?:number
  availWidth?:number
  colorDepth?:number
  deviceMemory?:number
  hardwareConcurrency?:number
  height?:number
  pixelDepth?:number
  vender?:string
  width?:number
}

export interface WpComponents{
  audio?:number
  canvas?:string
  canvasGeo?:string
  canvasText?:string
  colorDepth?:number
  colorGamut?:string
  contrast?:number
  cookiesEnabled?:boolean
  deviceMemory?:number
  fontPreferences?: Map<string, number>
  fonts?:string[]
  forcedColors?:boolean
  hardwareConcurrency?:number
  hdr?:boolean
  indexedDB?:boolean
  languages?:string[]
  localStorage?:boolean
  math?:Map<string, number>
  monochrome?:number
  openDatabase?:boolean
  platform?:string
  plugins?:Plugin[]
  reducedMotion?:boolean
  screenFrame?:number[]
  screenResolution?:number[]
  sessionStorage?:boolean
  timezone?:string
  touchSupport?:TouchSupport
  vendor?:string
  vendorFlavors?:string[]
}

export interface Plugin{
  name:string
  description:string
  mimeTypes?:MimeType[]
}

export interface MimeType{
  type:string
  suffixes:string
}

export interface TouchSupport{
  maxTouchPoints:number
  touchEvent?:boolean
  touchStart?:boolean
}